export const wrapperDataArrayConversor = (data) => ({
  loading: data === undefined,
  error: data === null, // this is a boolean, in future must be a significant object with the error
  data: data || [],
});
